module.exports = __webpack_public_path__ + "d9f1500d4b96b33ed004cbb57fdfccde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/calories-blue.png
// module id = 1879
// module chunks = 1